import { put, takeEvery, } from 'redux-saga/effects'
import { GET_IP_LOADING, GET_IP_SUCCESS, GET_IP_ERROR } from "../actions/actionIP";
import { getip } from '../api/ip'

async function fetchAsync(func) {
    const response = await func();
    if (response.ok) {
        return await response.json();
    }
}

function* fetchip() {
    try {
        const data = yield fetchAsync(getip)
        yield put({ type: GET_IP_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: GET_IP_ERROR, error: e.message });
    }
}

export const sagaIP = [
    takeEvery(GET_IP_LOADING, fetchip)
];
